export default __webpack_public_path__ + "static/media/retro-shoe.ee965cd2.jpg";